import React from "react";
import { Container, Box, Typography, Link } from "@mui/material";
import Banner from "../Banner";

const PrivacyPolicyPage = () => {
  return (
    
         <>
          <Banner />
    <Container maxWidth="md" sx={{ py: 5,pb: 8  }}>
      {/* Heading */}
      <Box textAlign="center" mb={4}>
        <Typography variant="h4" gutterBottom>
          Privacy Policy
        </Typography>
      </Box>

      <Box sx={{ "& > * + *": { mt: 2 } }}>
        {/* Introduction */}
        <Typography variant="h6">Introduction</Typography>
        <Typography>
          Plastindia Foundation (“the Foundation”, “we”, “us”, or “our”) is committed to safeguarding the privacy of its website visitors, event participants, and other stakeholders (“Users”). This Privacy Policy outlines how we collect, use, disclose, and protect your personal information. By accessing our website or using our services, you consent to the practices described in this Privacy Policy.
        </Typography>

        {/* 1. Information We Collect */}
        <Typography variant="h6">1. Information We Collect</Typography>
        <Typography>We may collect the following types of information:</Typography>
        <Box component="ul" pl={2}>
          <li>Name, email address, phone number, and mailing address.</li>
          <li>Professional details such as company name, job title, and industry affiliation (if applicable).</li>
          <li>Information provided during event registrations, surveys, or correspondence.</li>
        </Box>

        <Typography variant="h6">1.3 Payment Information</Typography>
        <Box component="ul" pl={2}>
          <li>
            If you make payments for registrations, donations, or other services, we collect payment details through secure third-party payment gateways. Plastindia Foundation does not store sensitive financial information such as credit card details.
          </li>
        </Box>

        {/* 2. How We Use Your Information */}
        <Typography variant="h6">2. How We Use Your Information</Typography>
        <Box component="ul" pl={2}>
          <li>To facilitate event registrations, communication, and participation.</li>
          <li>To provide updates about our initiatives, events, and programs.</li>
          <li>To improve our website and services by analyzing usage patterns and feedback.</li>
          <li>To comply with legal and regulatory obligations.</li>
          <li>For internal record-keeping and administrative purposes.</li>
        </Box>

        {/* 3. Sharing and Disclosure */}
        <Typography variant="h6">3. Sharing and Disclosure of Information</Typography>
        <Typography>
          We do not sell, rent, or trade your personal information to third parties. However, we may share your information in the following circumstances:
        </Typography>
        <Box component="ul" pl={2}>
          <li>
            <strong>Service Providers:</strong> With trusted third-party vendors for event management, email distribution, or data analysis, strictly for the purposes outlined in this policy.
          </li>
          <li>
            <strong>Legal Requirements:</strong> To comply with legal obligations, enforce our terms, or protect the rights and safety of Plastindia Foundation, its Users, or others.
          </li>
          <li>
            <strong>Consent:</strong> When you explicitly provide consent for specific purposes.
          </li>
        </Box>

        {/* 4. Cookies */}
        <Typography variant="h6">4. Cookies and Tracking Technologies</Typography>
        <Typography>
          We use cookies and similar technologies to enhance your experience on our website. These technologies help us:
        </Typography>
        <Box component="ul" pl={2}>
          <li>Understand how users interact with our website.</li>
          <li>Provide personalized content and recommendations.</li>
          <li>Track analytics and website performance.</li>
        </Box>
        <Typography>You can manage your cookie preferences through your browser settings.</Typography>

        {/* 5. Data Retention */}
        <Typography variant="h6">5. Data Retention</Typography>
        <Typography>
          We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy or to comply with legal obligations. When information is no longer required, we securely delete or anonymize it.
        </Typography>

        {/* 6. Data Security */}
        <Typography variant="h6">6. Data Security</Typography>
        <Box component="ul" pl={2}>
          <li>Secure servers and encrypted connections.</li>
          <li>Regular security assessments and updates.</li>
          <li>Restricted access to personal data to authorized personnel only.</li>
        </Box>
        <Typography>
          While we strive to protect your information, no system can guarantee absolute security. Users are advised to take precautions to safeguard their own devices and accounts.
        </Typography>
        <Typography>
          To exercise these rights, please contact us at{" "}
          <Link href="mailto:privacy@plastindia.org">privacy@plastindia.org</Link>.
        </Typography>

        {/* 7. Your Rights */}
        <Typography variant="h6">7. Your Rights</Typography>
        <Box component="ul" pl={2}>
          <li><strong>Access and Correction:</strong> Request access to your personal data or correct inaccuracies.</li>
          <li><strong>Deletion:</strong> Request the deletion of your personal information, subject to legal and operational requirements.</li>
          <li><strong>Objection and Restriction:</strong> Object to certain data processing activities or request limitations on how your data is used.</li>
          <li><strong>Data Portability:</strong> Request a copy of your data in a structured, machine-readable format.</li>
        </Box>
        <Typography>
          To exercise these rights, please contact us at{" "}
          <Link href="mailto:privacy@plastindia.org">privacy@plastindia.org</Link>.
        </Typography>

        {/* 8. Third-Party Links */}
        <Typography variant="h6">8. Third-Party Links</Typography>
        <Typography>
          Our website may contain links to external websites. Plastindia Foundation is not responsible for the privacy practices or content of these third-party websites. Users are encouraged to review the privacy policies of any external sites they visit.
        </Typography>

        {/* 9. Children’s Privacy */}
        <Typography variant="h6">9. Children’s Privacy</Typography>
        <Typography>
          Our website may contain links to external websites. Plastindia Foundation is not responsible for the privacy practices or content of these third-party websites. Users are encouraged to review the privacy policies of any external sites they visit.
        </Typography>

        {/* 10. International Data Transfers */}
        <Typography variant="h6">10. International Data Transfers</Typography>
        <Typography>
          Our website may contain links to external websites. Plastindia Foundation is not responsible for the privacy practices or content of these third-party websites. Users are encouraged to review the privacy policies of any external sites they visit.
        </Typography>

        {/* 11. Updates */}
        <Typography variant="h6">11. Updates to This Privacy Policy</Typography>
        <Typography>
          Plastindia Foundation reserves the right to update or modify this Privacy Policy at any time. Changes will be effective immediately upon posting on our website. We encourage Users to review this policy periodically to stay informed about our privacy practices.
        </Typography>

        {/* 12. Contact Information */}
        <Typography variant="h6">12. Contact Information</Typography>
        <Typography>Plastindia Foundation<br />
          401, Landmark B, Suren Road,<br />
          Off Andheri Kurla Road, Andheri (East),<br />
          Mumbai - 400093, India<br />
          <strong>Email:</strong>{" "}
          <Link href="mailto:privacy@plastindia.org">privacy@plastindia.org</Link><br />
          <strong>Phone:</strong> +91 22 26832911/15
        </Typography>

        {/* <Typography mt={4} variant="body2" color="text.secondary" textAlign="center">
          By using our website and services, you acknowledge that you have read and understood this Privacy Policy and agree to its terms.
        </Typography> */}
      </Box>
    </Container>
         
         </>
  );
};

export default PrivacyPolicyPage;
